import {
    BoxProps,
    FormHelperTextProps,
    GridProps,
    StackProps,
    SxProps,
    TypographyProps,
} from "@mui/material";
import muiVariables from "../../../styles/mui-variables";

const ProductDetailsStyle = {
    radioStackGrid: {
        marginInlineStart: {
            xs: "",
            sm: "16px !important",
            md: "16px !important",
            lg: "16px !important",
        },
    } as GridProps,
    mainStack: {
        direction: { xs: "column", sm: "row" },
        spacing: 2,
    } as StackProps,

    buttonStylesBox: {
        display: "flex",
        justifyContent: "end",
        gap: "15px",
        paddingTop: "20px"
    } as BoxProps,
    promoCodeModelBtnStack: {
        mt: 4,
        direction: "row",
        spacing: 2,
        alignItems: "center",
    } as StackProps,
    promoCodeModelBtnCancelSx: {
        width: "fit-content",
        backgroundColor: muiVariables.primaryColor,
        borderColor: muiVariables.borderColor,
        color: muiVariables.mainTextColor,
        "&:hover": {
            borderColor: muiVariables.borderColor,
        },
    } as SxProps,
    promoCodeModelBtnUpdateSx: {
        width: "fit-content",
        backgroundColor: muiVariables.primaryBtnColor,
        borderColor: muiVariables.borderColor,
        color: `${muiVariables.primaryColor}`,
    } as SxProps,
    extraProductModelMainGrid: {
        maxWidth: "100%",
        alignItems: { sm: "center", lg: "flex-start" },
        justifyContent: { sm: "center", lg: "flex-start" },
    } as GridProps,
    discountFormHelperText: {
        sx: {
            marginTop: "5px !important",
            paddingLeft: "5px !important",
            color: `${muiVariables.errorMessageColor}`,
        },
    } as FormHelperTextProps,
    mainButtonsBox: {
        height: "74px",
        width: "100%",
        bottom: "0",
        borderTop: `1px solid ${muiVariables.borderColor}`,
        sx: {
            position: "fixed",
            marginTop: { xs: 5, sm: 5 },
            backgroundColor: "rgb(255,255,255)",
        },
    } as BoxProps,
    mainButtonsSubBox: {
        sx: {
            display: "flex",
            flexDirection: "row",
            pt: 2,
            alignItems: "center",
        },
    } as BoxProps,
    mainButtonsPositionBox: {
        sx: {
            flex: "1 1 auto",
            mr: { lg: 3, sm: 3, md: 3 },
            textAlign: "end",
            padding: { xs: "0 16px 0 16px" },
        },
    } as BoxProps,
    mainBackBtnSx: {
        width: { xs: "100%", sm: "fit-content" },
        backgroundColor: muiVariables.primaryColor,
        borderColor: muiVariables.borderColor,
        color: muiVariables.mainTextColor,
        "&:hover": {
            borderColor: muiVariables.borderColor,
        },
    } as SxProps,
    mainSaveBtnSx: {
        width: { xs: "100%", sm: "fit-content" },
        whiteSpace: { xs: "nowrap" },
        backgroundColor: muiVariables.primaryBtnColor,
        borderColor: muiVariables.borderColor,
        color: `${muiVariables.primaryColor}`,
    } as SxProps,

    productDetailsBox: {
        padding: "20px"
    } as BoxProps,
    productDetailsGrid: {
        maxWidth: "100%",
    } as GridProps,
    startDateFormHelperText: {
        sx: {
            marginTop: "5px !important",
            paddingLeft: "3px !important",
            paddingRight: "3px !important",
            textAlign: "start",
            color: `${muiVariables.errorMessageColor}`,
        },
    } as FormHelperTextProps,

    productDetailsSaveBtnSx: {
        width: { xs: "100%", sm: "fit-content" },
        backgroundColor: muiVariables.primaryBtnColor,
        borderColor: muiVariables.borderColor,
        color: `${muiVariables.primaryColor}`,
    } as SxProps,
    helperText: {
        marginTop: "5px !important",
        paddingLeft: "5px !important",
        color: `${muiVariables.errorMessageColor}`,
    } as SxProps,
    infoText: {
        fontSize: "13px",
        fontWeight: "500",
        color: muiVariables.primaryBtnColor,
        display: "flex",
        marginTop: "5px !important",
        justifyContent: "end",
    } as TypographyProps,
    radioGroupWrap: {
        direction: { xs: "column", sm: "row" },
        alignItems: { xs: "", sm: "start" },
        spacing: 2,
    } as StackProps,
};

export default ProductDetailsStyle;
